import copy from 'copy-to-clipboard';

export default class CopyToClipboard {
	constructor() {
		document.addEventListener('click', e => {
			const target = e.target;

			if (target.closest('[data-copy-to-clipboard]')) {
				copy(target.dataset.copyToClipboard);

				target.classList.add('is-active');

				setTimeout(() => {
					target.classList.remove('is-active');
				}, 1000);
			}
		});
	}
}
